import { AxiosInstance, AxiosResponse } from "axios";
import { AdhesionApiFactory, Fidelite } from "./swagger";

export interface IApi {
  getFideliteByNumeroAdhesion(numeroAdhesion: string): Promise<Fidelite>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const fideliteApi = AdhesionApiFactory({}, endpoint, axiosClient);

  const getFideliteByNumeroAdhesion = (numeroAdhesion): Promise<Fidelite> =>
    new Promise((resolve, reject) => {
      fideliteApi
        .getFideliteByNumeroAdhesion(numeroAdhesion)
        .then((response: AxiosResponse<Fidelite>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  return {
    getFideliteByNumeroAdhesion,
  };
};

export default create;
